import { Injectable, Type } from '@angular/core';

/**
 * 
 */
@Injectable({
  providedIn: 'root'
})
export class ComponentProviderService {

  protected default: Type<any>;
  protected collection: {[key: string]: any};

  constructor(component: Type<any>) {
    this.default = component;
    this.collection = {};
  }

  public get(type: string): Type<any> {
    const found = this.collection[type];
    return found || this.default;
  }
}
